import axios from "./axios";
import useAuth from "./auth/useAuth";
import { useNavigate } from "react-router";

const useLogout = () =>{
    const {setAuth} = useAuth();
    const Navigate = useNavigate()
    const logout = async () => {
        
        try{
            const response = await axios.post('/api/auth/logout', {}, {
                withCredentials: true
            });
            console.log(response)
            setAuth({});
            Navigate('/login');

        }
        catch(error){
            console.log(error);
        }
    }
    return logout;
    
}

export default useLogout;